import React, { FC } from 'react'
import SingleQuestion from './SingleQuestion'
import { Questions } from '@mortgage-pos/types'
import useCustomValidation from '@mortgage-pos/ui/hooks/useCustomValidation'
import { useShouldShowQuestion } from '@mortgage-pos/ui/utils/visibleIf'
import { useStoreState } from '@mortgage-pos/ui/store'

interface Props {
  title?: string
  subTitle?: string
  questionGroupName: string
  questionGroupValues: object
  questionGroupIndex?: number
  questions: Questions[]
  customValidationKey?: string
  customValidationCallback?: Function
}

export const QuestionsList: FC<Props> = ({
  title,
  subTitle,
  questionGroupName,
  questionGroupValues,
  questionGroupIndex = 0,
  questions,
  customValidationKey,
  customValidationCallback,
}) => {
  useCustomValidation(
    questionGroupValues,
    customValidationKey,
    customValidationCallback
  )

  return (
    <>
      {title ? <h2 className="questions-list__title">{title}</h2> : null}
      {subTitle ? <p className="questions-list__subtitle">{subTitle}</p> : null}
      {questions.map((question) => (
        <QuestionListQuestion
          key={question.questionName.name}
          question={question}
          group={{
            name: questionGroupName,
            values: questionGroupValues,
            index: questionGroupIndex,
          }}
        />
      ))}
    </>
  )
}

const QuestionListQuestion = ({ question, group }) => {
  const {
    name: questionGroupName,
    values: questionGroupValues,
    index: questionGroupIndex,
  } = group
  const prebuiltValidations = useStoreState(
    (state) => state.visibleIfConditions
  )
  const shouldShowQuestion = useShouldShowQuestion(
    questionGroupValues,
    question,
    prebuiltValidations
  )

  if (!shouldShowQuestion) {
    return null
  }

  const questionName: string = question.questionName.name

  const questionGroup = questionGroupName + `[${questionGroupIndex}]`

  // Formik convention for Fields within a FieldArray - object[index].property
  // https://formik.org/docs/api/fieldarray#fieldarray-array-of-objects
  const newName = questionGroup + '.' + questionName

  const newQuestion = {
    ...question,
    questionName: { name: newName },
  }

  return (
    <SingleQuestion
      question={newQuestion}
      key={newName}
      questionGroup={questionGroup}
      questionGroupValues={questionGroupValues}
    />
  )
}
